import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/glyph/copy';
import Tooltip from '@atlaskit/tooltip';
import messages from './messages';
/* *
 * TODO: AIFOLLOWUP
 * When playwright has cross browser support, make sure to test it:
 * ./__tests__/playwright/copy-paste.ai-test.ts
 *
 * TODO: AIFOLLOWUP
 * This needs extensive manual cross-browser testing as part of EAP.
 * */
export var CopyIconButton = function CopyIconButton(_ref) {
  var onClick = _ref.onClick,
    tabIndex = _ref.tabIndex,
    appearance = _ref.appearance,
    spacing = _ref.spacing;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _React$useState = React.useState(formatMessage(messages.copy)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tooltip = _React$useState2[0],
    setTooltip = _React$useState2[1];
  var updateTooltip = React.useRef();
  var handleOnClick = React.useCallback(function (event) {
    onClick(event);
    setTooltip(formatMessage(messages.copiedToClipboard));
  }, [onClick, formatMessage]);
  var resetTooltip = React.useCallback(function () {
    return setTooltip(formatMessage(messages.copy));
  }, [formatMessage]);
  React.useLayoutEffect(function () {
    var _updateTooltip$curren;
    (_updateTooltip$curren = updateTooltip.current) === null || _updateTooltip$curren === void 0 || _updateTooltip$curren.call(updateTooltip);
  }, [tooltip]);
  return jsx(Tooltip, {
    content: function content(_ref2) {
      var update = _ref2.update;
      updateTooltip.current = update;
      return tooltip;
    },
    position: "top",
    onHide: resetTooltip
  }, jsx(IconButton, {
    testId: "copy-response-button",
    type: "button",
    onClick: handleOnClick,
    icon: CopyIcon,
    label: tooltip,
    appearance: appearance,
    spacing: spacing,
    tabIndex: tabIndex
  }));
};